import styled from 'styled-components'

const InformativeSliderGalleryStyle = styled.div`
    --isgMarginBottom: var(--sp9x);
    --isgDescriptionMarginTop: var(--sp7x);

    .isg-info-container {
        margin-bottom: var(--isgMarginBottom);

        .isg-title + .isg-description {
            margin-top: var(--isgDescriptionMarginTop);
        }
    }

    @media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeL}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXLMin}) {
        --isgMarginBottom: var(--sp7x);
        --isgDescriptionMarginTop: var(--sp5x);
    }

    @media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeM}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeLMin}) {
        --isgMarginBottom: var(--sp6x);
        --isgDescriptionMarginTop: var(--sp4x);
    }

    @media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeMMin}) {
        --isgMarginBottom: var(--sp6x);
        --isgDescriptionMarginTop: var(--sp4x);
    }

    @media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeSMin}) {
        --isgMarginBottom: var(--sp6x);
        --isgDescriptionMarginTop: var(--sp4x);
    }

    @media only screen and (min-width: ${({ theme }) => theme.mediaQuery.TabletSize}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXSMin}) {
        --isgMarginBottom: var(--sp6x);
        --isgDescriptionMarginTop: var(--sp3x);
    }

    @media only screen and (min-width: ${({ theme }) => theme.mediaQuery.TabletSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeMin}) {
        --isgMarginBottom: var(--sp4x);
        --isgDescriptionMarginTop: var(--sp3x);
    }


    @media only screen and (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeSMin}) {
        --isgMarginBottom: var(--sp4x);
        --isgDescriptionMarginTop: var(--sp3x);
    }
    
`

export default InformativeSliderGalleryStyle